var _defs, _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _path2, _path3, _path4, _g8, _g9, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "307 89.66 410 396.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9aeb281495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 516 296 L 717 296 L 717 486.222656 L 516 486.222656 Z M 516 296 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6e4f3138bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 516 323 L 617 323 L 617 486.222656 L 516 486.222656 Z M 516 323 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cab4d89e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 307.003906 89.664062 L 402 89.664062 L 402 486.222656 L 307.003906 486.222656 Z M 307.003906 89.664062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7509105b69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413 173 L 508 173 L 508 486.222656 L 413 486.222656 Z M 413 173 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75d7c24379"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 376 89.664062 L 402 89.664062 L 402 189 L 376 189 Z M 376 89.664062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fad0e2758f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 307.003906 157 L 325 157 L 325 486.222656 L 307.003906 486.222656 Z M 307.003906 157 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dc679d868"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 337 122 L 365 122 L 365 486.222656 L 337 486.222656 Z M 337 122 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44c15ec0d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413 396 L 462 396 L 462 486.222656 L 413 486.222656 Z M 413 396 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5de708ce4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413 89.664062 L 508 89.664062 L 508 204 L 413 204 Z M 413 89.664062 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9aeb281495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M 716.992188 342.378906 L 716.992188 323.96875 C 716.992188 308.726562 672.128906 296.375 616.785156 296.375 C 561.441406 296.375 516.574219 308.726562 516.574219 323.96875 L 516.574219 486.316406 L 716.992188 486.316406 L 716.992188 473.722656 C 716.992188 470.425781 714.871094 467.25 710.976562 464.320312 C 697 453.699219 660.09375 446.128906 616.792969 446.128906 L 616.792969 427.292969 C 672.125 427.292969 716.992188 439.625 716.992188 454.886719 L 716.992188 436.21875 C 716.992188 432.921875 714.871094 429.75 710.976562 426.816406 C 697 416.195312 660.09375 408.625 616.792969 408.625 L 616.792969 389.789062 C 672.125 389.789062 716.992188 402.125 716.992188 417.386719 L 716.992188 398.71875 C 716.992188 395.421875 714.871094 392.246094 710.976562 389.316406 C 697 378.691406 660.09375 371.121094 616.792969 371.121094 L 616.792969 352.289062 C 672.125 352.289062 716.992188 364.621094 716.992188 379.882812 L 716.992188 361.214844 C 716.992188 357.917969 714.871094 354.742188 710.976562 351.8125 C 697 341.191406 660.09375 333.621094 616.792969 333.621094 L 616.792969 314.785156 C 672.125 314.785156 716.992188 327.117188 716.992188 342.378906 Z M 716.992188 342.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6e4f3138bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 516.574219 323.96875 L 516.574219 486.316406 L 616.785156 486.316406 C 528.882812 418.464844 516.574219 323.96875 516.574219 323.96875 Z M 516.574219 323.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cab4d89e7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#235a86",
    d: "M 401.195312 486.316406 L 307.003906 486.316406 L 401.195312 89.675781 Z M 401.195312 486.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7509105b69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#235a86",
    d: "M 413.40625 486.316406 L 507.597656 486.316406 L 507.421875 173.835938 Z M 413.40625 486.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 376.339844 337.457031 L 401.230469 323.847656 L 401.230469 266.78125 L 376.339844 283.828125 Z M 376.339844 337.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75d7c24379)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 376.339844 188.148438 L 401.539062 166.539062 L 401.195312 89.675781 L 376.339844 111.785156 Z M 376.339844 188.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fad0e2758f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 324.882812 157.5625 L 307.003906 173.464844 L 307.003906 486.316406 L 324.882812 486.316406 Z M 324.882812 157.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dc679d868)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 364.128906 292.1875 L 354.886719 298.519531 L 354.886719 206.542969 L 364.128906 198.617188 L 364.128906 122.648438 L 337.09375 146.699219 L 337.09375 486.316406 L 354.886719 486.316406 L 354.886719 349.183594 L 364.128906 344.132812 Z M 364.128906 292.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 413.230469 311.050781 L 461.113281 348.445312 L 461.113281 347.832031 L 482.738281 365.328125 L 507.460938 384.632812 L 507.460938 338.675781 L 465.070312 305.214844 L 413.230469 264.734375 Z M 413.230469 311.050781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 413.230469 191.949219 L 460.5 229.964844 L 460.5 209.980469 L 507.753906 247.152344 L 507.628906 219.589844 L 413.230469 141.625 Z M 413.230469 191.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 460.5 286.15625 L 460.5 245.632812 L 413.230469 207.617188 L 413.230469 249.242188 Z M 460.5 286.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44c15ec0d5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 413.230469 396.566406 L 413.230469 486.316406 L 461.113281 486.316406 L 461.113281 433.957031 Z M 413.230469 396.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5de708ce4a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 507.558594 203.695312 L 507.421875 173.835938 L 413.230469 89.738281 L 413.230469 125.789062 Z M 507.558594 203.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ccf",
    d: "M 461.113281 363.933594 L 413.230469 326.542969 L 413.230469 381.074219 L 461.113281 418.464844 Z M 461.113281 363.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImage);
export default __webpack_public_path__ + "static/media/landing-image.d6875820ff43da5734977cb30a85acd9.svg";
export { ForwardRef as ReactComponent };